import type { ColorStatus } from "@color-finder/color-finder-api/models";
import { Chip } from "@mui/material";

export interface ColorStatusProps {
  value: ColorStatus;
  size?: "small" | "medium";
  variant?: "outlined" | "filled";
}

const colorMapping: Record<ColorStatus, "success" | "warning" | "primary"> = {
  ACTIVE: "success",
  INACTIVE: "warning",
  UNKNOWN: "primary",
};

function ColorStatusDisplay({
  value,
  size = "small",
  variant = "outlined",
}: ColorStatusProps) {
  return (
    <Chip
      variant={variant}
      color={colorMapping[value]}
      size={size}
      style={{ textTransform: "capitalize" }}
      label={value === "UNKNOWN" ? "Under development" : value?.toLowerCase()}
    />
  );
}

export default ColorStatusDisplay;
